import { ArrowLeft } from 'lucide-react';

export function NotFoundPage({
  homeHref = '/',
  homeLabel = 'Back home',
}: {
  homeHref?: string;
  homeLabel?: string;
}) {
  return (
    <>
      <main id="content" className="not-found shell" tabIndex={-1}>
        <p className="eyebrow">404 · Nothing here</p>
        <h1>This page has left the workbench.</h1>
        <p>The link may be old, or the page may still be taking shape.</p>
        <a className="button button-dark" href={homeHref}>
          <ArrowLeft size={18} aria-hidden="true" /> {homeLabel}
        </a>
      </main>
    </>
  );
}
